import Vue from "vue";

const state = {
    profile: null, 
    accountOwner: false,
    userDetiledCids: null,
    userCallSettingsRedirect: null, // if redirected from did manager to config clid
    displayExtraDids: false, // in case user redirect to dids from add extra international number 
    didRedirect: false, //for redirect from user's device
    didRedirectNumber: null, //     ---//---    ---//---
};
const getters = {
  getUserProfile: (state) => state.profile,
  getDetailedCids: state => state.userDetiledCids,
};

const actions = {
    setUserProfile({ commit }, userProfile) {
        commit('SET_USER_PROFILE', userProfile);
    },
    setAccountOwner({ commit }, accountOwnerStatus) {
      commit('SET_ACCOUNT_OWNER', accountOwnerStatus)
    },
    setUserDetailedCidList({ commit }, detailedList) {
      commit('SET_USER_DETAILED_CID_LIST', detailedList)
    },
    setUserCallSettingsRedirect({ commit }, selectedService) {
      commit('SET_USER_CALL_SETTINGS_REDIRECT', selectedService)
    },
    setDisplayExtraDids({ commit }, boolVal) {
      commit('SET_DISPLAY_EXTRA_DIDS', boolVal)
    },
    setDidRedirect({ commit }, boolVal) {
      commit('SET_DID_REDIRECT', boolVal)
    },
    setRedirectDIDnumber({ commit }, didNumber) {
      commit('SET_DID_REDIRECT_NUMBER', didNumber)
    },
    logoutUser({ commit }) {
      commit('SET_USER_PROFILE', null);
      commit('SET_ACCOUNT_OWNER', false)
      commit('SET_USER_DETAILED_CID_LIST', null)
      commit('SET_DID_REDIRECT', false)
      commit('SET_DID_REDIRECT_NUMBER', null)
    },
};

const mutations = { 
  SET_USER_PROFILE(state, userProfile) {
    Vue.set(state, "profile", userProfile);
  },
  SET_ACCOUNT_OWNER(state, accountOwnerStatus) {
    state.accountOwner = accountOwnerStatus
  },
  SET_DID_REDIRECT(state, mode) {
    state.didRedirect = mode
  },
  SET_DID_REDIRECT_NUMBER(state, didNumber) {
    state.didRedirectNumber = didNumber
  },
  SET_USER_DETAILED_CID_LIST(state, detailedList) {
    Vue.set(state, "userDetiledCids", detailedList);
  },
  SET_USER_CALL_SETTINGS_REDIRECT(state, selectedService) {
    state.userCallSettingsRedirect = selectedService
    // Vue.set(state, "userCallSettingsRedirect", selectedService);
  },
  SET_DISPLAY_EXTRA_DIDS(state, boolVal) {
    state.displayExtraDids = boolVal
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
